import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from 'src/app/shared';
import { ComponentTypes, Attributes } from 'src/app/model/ui-rule-response-model';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class configDataResolver implements Resolve<any> {
    constructor(private httpClient: HttpClient) { }
    private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        let fetchConfigData: string;
        if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
            fetchConfigData = this.endPoints["configData"];
        } else {
            fetchConfigData = this.endPoints["configData"];
        }
        return this.httpClient.get(fetchConfigData).toPromise().then(res => {
            if (res) {
                //console.log(res);
                return res;
            }
        });
    }
}